import React from "react";

export default function EllipseNotEditableIcon(props) {
  return (
    <svg width={9} height={9} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="4.5" cy="4.5" r="4.5" fill="#2B56A3" />
    </svg>
  );
}
